import requestUtil from "../../helpers/requestUtil";
import { setLoading } from "../common/Loader/slice";
import contactList from './contactList.json';
import {
    deleteEmployerUserError, deleteEmployerUserSuccess, getcontactListError,
    getContactListSuccess, getLocationDropdownError, getLocationDropdownSuccess, setContactLoader, setLoadingFlagDecrement, setLoadingFlagIncrement
} from "./slice";

export function getContactList(url, employerUniqueId, locationId) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement())
        dispatch(setContactLoader(true));

        try {
            const response = await requestUtil(`${url}/Locations/getcontactlist`, "POST",
                {
                    "page": 0,
                    "pageSize": 0,
                    "sortOrder": "string",
                    "sortColumn": "string",
                    "locationId": locationId,
                    "employeruniqeId": employerUniqueId
                })
                dispatch(getContactListSuccess(response.contacts));
        }catch(error){
            dispatch(getcontactListError(error.message));
        } finally {
            dispatch(setLoadingFlagDecrement())
            dispatch(setContactLoader(false));
        }
    };
}

export function getLocationDropdownList(url, employerId) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/Locations/get-location-list-for-dropdown-by-employerid/${employerId}`, "GET",)
            dispatch(getLocationDropdownSuccess(response));
        }catch(error){
            dispatch(getLocationDropdownError(error.message));
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}

export function deleteEmployerUser(url, contactId, employerId) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/EmployerUsers/deleteemployeruser/${contactId}`, "POST")
            dispatch(deleteEmployerUserSuccess(response.message));
        }catch(error){
            dispatch(deleteEmployerUserError(error.message));
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}
export function updatesuccessmessage(data) {
    return async (dispatch) => {
        dispatch(deleteEmployerUserSuccess(data));
    };

}